module.exports = __webpack_public_path__ + "img/2.fdd85e98.jpg";